import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dropdown } from "antd";
import BulkEditShipment from "./BulkEditShipment";
import CustomModal from "../../components/CustomModal";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Button } from "@vds/buttons";
import { updateUI, bulkDeleteRequest, fetchProfileRequest, downloadRequest, updateBulkSelect } from "../../store/actions/shipment";
import BulkUpdateStateShipment from "./BulkUpdateStateShipment";
import BulkCancelStateShipment from "./BulkCancelStateShipment";

const ShipmentDropdown = () => {
  const dispatch = useDispatch();
  const {
    isBulkMaerkAsCompletedOpen,
    isBulkCancelOpen,
    isBulkEditOpen,
    bulkDeleteShipConfirmed,
    bulkCancelShipConfirmed,
    selectedFields,
    selectedBulkEditFields,
  } = useSelector((state) => ({
    isBulkMaerkAsCompletedOpen: state.shipment.ui.edit.bulkUpdateState,
    isBulkCancelOpen: state.shipment.ui.cancel.bulkUpdateState,
    isBulkEditOpen: state.shipment.ui.edit.bulkEdit,
    bulkDeleteShipConfirmed: state.shipment.ui.delete.bulkDelete,
    bulkCancelShipConfirmed: state.shipment.ui.cancel.bulkCancel,
    selectedBulkEditFields:
      Array.isArray(state.shipment.ui.selectedFields) &&
        state.shipment.ui.selectedFields.length > 0
        ? state.shipment.ui.selectedFields.map(
          (selectedField) => selectedField?.record?.state
        )
        : [],
    selectedFields:
      Array.isArray(state.shipment.ui.selectedFields) &&
        state.shipment.ui.selectedFields.length > 0
        ? state.shipment.ui.selectedFields.map(
          (selectedField) => selectedField?.record?.shipmentName
        )
        : [],
  }));

  const handleBulkDelete = () => {
    dispatch(
      updateUI({
        key: "delete",
        value: {
          bulkDelete: !bulkDeleteShipConfirmed,
        },
      })
    );
  };
  const handleBulkCancel = () => {
    dispatch(
      updateUI({
        key: "cancel",
        value: {
          bulkCancel: !bulkCancelShipConfirmed,
        },
      })
    );
  };

  const handleDownload = () => {
    dispatch(
      downloadRequest()
    );
  };

  const onExit = () => {
    dispatch(
      updateBulkSelect([]))
    dispatch(
      updateUI({
        key: "delete",
        value: {
          bulkDelete: false,
        },
      })
    );
  };
  const onConfirm = () => {
    dispatch(bulkDeleteRequest());
    dispatch(
      updateUI({
        key: "delete",
        value: {
          bulkDelete: false,
        },
      })
    );
  };

  const handleBulkEdit = (e) => {
    e.preventDefault();
    let bulkEditFormData = {
      state: "",
      startDate: new Date(),
      profile: undefined,
      onShipmentCompletion: undefined
    };

    if (!isBulkEditOpen) {
      let selectedState = {};
      if (
        Array.isArray(selectedBulkEditFields) &&
        selectedBulkEditFields.length > 0
      ) {
        selectedBulkEditFields.forEach((el) => {
          if (!selectedState[el]) {
            selectedState = {
              ...selectedState,
              [el]: 1,
            };
          } else {
            selectedState = {
              ...selectedState,
              [el]: parseInt(selectedState[el]) + 1,
            };
          }
        });
      }

      let selectedStateArr = Object.entries(selectedState);

      if (selectedStateArr.length > 0) {
        const allStateOptions = selectedStateArr.map((el) => el[0]);

        if (allStateOptions.every((el) => el === "Scheduled")) {
          bulkEditFormData = {
            ...bulkEditFormData,
            state: "Scheduled",
          };
        } else {
          selectedStateArr = selectedStateArr.filter((el) => el[0] !== "Scheduled")
          selectedStateArr.sort(function (a, b) {
            return b[1] - a[1];
          });
          bulkEditFormData = {
            ...bulkEditFormData,
            state: selectedStateArr[0][0],
          };
        }
      }
    }

    dispatch(
      updateUI({
        key: "edit",
        value: {
          bulkEdit: !isBulkEditOpen,
          bulkEditFormData,
        },
      })
    );
    dispatch(fetchProfileRequest());
  };

  const handleMarkAsCompleted = (e) => {
    dispatch(
      updateUI({
        key: "edit",
        value: {
          bulkUpdateState: !isBulkMaerkAsCompletedOpen,
        },
      })
    );
  }
  const items = [
    {
      label: <span className="font-face-vzw">Action</span>,
      key: "0",
    },
    !selectedBulkEditFields.includes('Scheduled') &&!selectedBulkEditFields.includes('Cancelled') && !selectedBulkEditFields.includes('Completed')?  {
      label: (
        <button onClick={handleMarkAsCompleted} className="ats-text-btn">
          Complete all
        </button>
      ),
      key: "4",
    } : '',
    
      !selectedBulkEditFields.includes('Cancelled') && !selectedBulkEditFields.includes('Completed')?{
      label: (
        <button onClick={handleBulkCancel} className="ats-text-btn">
          Cancel all
        </button>
      ),
      key: "5",
    }
      : '',
    !selectedBulkEditFields.includes('Cancelled') && !selectedBulkEditFields.includes('Completed')?{
      label: (
        <button onClick={handleBulkEdit} className="ats-text-btn">
          Edit all
        </button>
      ),
      key: "1",
    }: '',

    {
      label: (
        <button onClick={handleBulkDelete} className="ats-text-btn">
          Delete all
        </button>
      ),
      key: "2",
    },
    {
      label: (
        <button onClick={handleDownload} className="ats-text-btn">
          Export
        </button>
      ),
      key: "3",
    },
  ];

  return (
    <>
      <Dropdown
        menu={{
          items,
        }}
        trigger={["click"]}
        overlayClassName="shipment-dropdown-overlay"
      >
        <button className="btn btn-link text-secondary">
          <i className="bi-three-dots-vertical fs-6" />
        </button>
      </Dropdown>
      <CustomModal modalKey={"bulkDeleteShipConfirmed"} popupName={''} customClass={'deleteAlertGroup'} popupTitle={'Delete shipment'} open={bulkDeleteShipConfirmed}>
        <>
          <p style={{ padding: '5px', marginTop: '25px', paddingLeft: '0px' }}><>
            <span>Are you sure you want to delete all {selectedFields?.length} selected shipments?</span>
            {/* <span>Are you sure you'd like to delete the Shipment </span> 
            <span
              style={{
                fontWeight: "700",
                fontFamily: "VerizonNHGDSBold",
                fontSize: "16px",
              }}
            >
              {selectedFields.join(", ")}?
            </span>{" "}*/}
            <br />
            <span>
              Deleting these shipments, will permanently remove the data of the shipments.
            </span>
          </></p>
          <Grid2
            container
            marginTop={1}
            marginBottom={0}
            spacing={1}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-cancel"
                  type="default"
                  shape="round"
                  style={{ fontWeight: "bold", width: "100%", backgroundColor: "white", color: "black", }}
                  onClick={() => onExit()}
                  size={"large"}
                >
                  No, cancel
                </Button>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-save"
                  type="primary"
                  shape="round"
                  onClick={() => {
                    onConfirm()
                  }}
                  style={{ fontWeight: "bold", width: "100%" }}
                  size={"large"}
                >
                  Yes, delete
                </Button>
              </div>
            </Grid2>
          </Grid2>
        </>
      </CustomModal>
      <BulkEditShipment />
      <BulkUpdateStateShipment />
      <BulkCancelStateShipment />
    </>
  );
};
export default ShipmentDropdown;